import { Check, Phone } from "lucide-react";
import { COMPANY, IMAGES, WHY_US, buildWhatsAppLink } from "../../lib/constants";

export const WhyUs = () => {
    return (
        <section
            id="por-que"
            data-testid="whyus-section"
            className="bg-[#f8f9fa] py-20 md:py-28"
        >
            <div className="container mx-auto px-4 md:px-8">
                <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                    {/* Image */}
                    <div className="relative order-2 lg:order-1">
                        <div className="relative overflow-hidden">
                            <img
                                src={IMAGES.whyUs}
                                alt="Guincho RCM transportando Fiat Siena com segurança em Praia Grande"
                                className="w-full h-[420px] md:h-[560px] object-cover"
                            />
                            {/* Bottom info card */}
                            <div className="absolute bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-6 bg-white/95 backdrop-blur-sm p-4 md:p-5 border-l-4 border-[#f45100]">
                                <div className="flex items-center gap-4">
                                    <div className="text-3xl md:text-4xl font-display font-black text-[#f45100]">
                                        4.9
                                    </div>
                                    <div>
                                        <div className="flex gap-0.5 text-[#f45100]">
                                            {[...Array(5)].map((_, i) => (
                                                <span key={i}>★</span>
                                            ))}
                                        </div>
                                        <div className="text-xs font-bold uppercase tracking-wider text-black">
                                            187+ clientes atendidos em Praia
                                            Grande
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Decorative orange block */}
                        <div className="hidden md:block absolute -bottom-6 -left-6 w-32 h-32 bg-[#f45100] -z-10" />
                        <div className="hidden md:block absolute -top-6 -right-6 w-24 h-24 emergency-stripes -z-10" />
                    </div>

                    {/* Content */}
                    <div className="order-1 lg:order-2">
                        <span className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100]">
                            · Por que escolher a RCM ·
                        </span>
                        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight text-black mt-3 leading-[0.95]">
                            Confiança que se mede em{" "}
                            <span className="text-[#f45100]">minutos</span> de
                            espera.
                        </h2>
                        <p className="mt-5 text-gray-600 text-base md:text-lg max-w-xl">
                            Não somos um aplicativo. Somos uma empresa local com
                            equipe própria, frota dedicada e CNPJ ativo —
                            atendendo motoristas de Praia Grande há anos.
                        </p>

                        <ul className="mt-8 grid sm:grid-cols-2 gap-3">
                            {WHY_US.map((item, i) => (
                                <li
                                    key={i}
                                    data-testid={`whyus-item-${i}`}
                                    className="flex items-start gap-3"
                                >
                                    <span className="flex-shrink-0 w-6 h-6 mt-0.5 bg-[#f45100] flex items-center justify-center">
                                        <Check
                                            size={14}
                                            strokeWidth={3}
                                            className="text-white"
                                        />
                                    </span>
                                    <span className="text-sm md:text-[15px] font-medium text-black leading-snug">
                                        {item}
                                    </span>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-9 flex flex-col sm:flex-row gap-3">
                            <a
                                href={buildWhatsAppLink()}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="whyus-whatsapp-btn"
                                className="inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#0a0a0a] hover:bg-[#f45100] text-white rounded-xl font-bold text-sm uppercase tracking-wider transition-all hover:scale-[1.02]"
                            >
                                Solicitar atendimento agora
                            </a>
                            <a
                                href={COMPANY.phoneTel}
                                data-testid="whyus-phone-btn"
                                className="inline-flex items-center justify-center gap-2 px-6 py-4 bg-transparent border-2 border-black hover:bg-black hover:text-white text-black rounded-xl font-bold text-sm uppercase tracking-wider transition-all"
                            >
                                <Phone size={16} strokeWidth={2.5} />
                                {COMPANY.phone}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
